export class AppUtils {
	static get isDev() {
		try {
			return process.env.NODE_ENV !== "production";
		}
		catch (e) {
			return undefined;
		}
	}

	static get isProduction() {
		try {
			return process.env.NODE_ENV === "production";
		}
		catch (e) {
			return undefined;
		}
	}

	static get localStorageTheme() {
		return localStorage.getItem("theme") || undefined;
	}

	static get systemTheme() {
		return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light";
	}

	static detectTheme({detectFromStorage = true, detectFromSystem = true, defaultTheme = "light"} = {}) {
		return (detectFromStorage ? this.localStorageTheme : undefined) || (detectFromSystem ? this.systemTheme : undefined) || defaultTheme;
	}
}
